import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { Element } from 'react';
import { Img } from './Img';
import styled from 'styled-components';
import PropTypes from 'prop-types';
const ImageContainer = styled.div.withConfig({
  displayName: "ImageContainer",
  componentId: "sc-15klkof-0"
})(["height:", ";margin:auto;position:absolute;top:0;bottom:0;left:0;right:0;text-align:center;"], props => {
  var _props$height;
  return (_props$height = props === null || props === void 0 ? void 0 : props.height) !== null && _props$height !== void 0 ? _props$height : '100%';
});
export const ImageFullCentered = React.forwardRef(function ImageFullCentered(props, ref) {
  const {
    style,
    title,
    imageFullCentered,
    state,
    bgColor,
    LQIP,
    alt,
    placeholderStyle,
    src,
    imageRef,
    onError,
    handleImageLoaded,
    imageStyle
  } = props;
  const loadedImgStyle = _objectSpread(_objectSpread({}, imageStyle), {}, {
    position: 'initial',
    width: 'auto',
    margin: '0 auto'
  });
  return React.createElement("div", {
    style: _objectSpread({
      position: 'relative',
      overflow: 'hidden'
    }, style),
    ref: ref
  }, React.createElement("div", {
    style: {
      width: '100%',
      paddingBottom: "".concat(100 / (imageFullCentered.aspectRatio.split(':')[0] / imageFullCentered.aspectRatio.split(':')[1]), "%")
    }
  }), (bgColor || !LQIP) && React.createElement("div", {
    title: title,
    style: {
      background: bgColor,
      position: 'absolute',
      top: 0,
      bottom: 0,
      opacity: state.imgLoaded ? 0 : 1,
      transitionDelay: '0.35s',
      right: 0,
      left: 0
    }
  }), LQIP && React.createElement(ImageContainer, {
    height: imageFullCentered.imageHeight
  }, React.createElement(Img, {
    src: LQIP,
    title: title,
    alt: alt,
    loading: "eager",
    style: _objectSpread(_objectSpread({
      opacity: state.imgLoaded ? 0 : 1,
      transition: 'opacity 0.5s',
      transitionDelay: state.imgLoaded ? '0.5s' : '1s'
    }, loadedImgStyle), placeholderStyle)
  })), (state.seenBefore || state.isVisible) && React.createElement(React.Fragment, null, state.origin === 'xceed' && React.createElement("picture", null, React.createElement("source", {
    srcSet: state.srcSet,
    sizes: "(height: ".concat(imageFullCentered.height, "px) 100vh, ").concat(imageFullCentered.height, "px")
  }), React.createElement(ImageContainer, {
    height: imageFullCentered.imageHeight
  }, React.createElement(Img, {
    alt: alt,
    title: title,
    src: "".concat(src, "?h=").concat(imageFullCentered.height).concat(state.parsedOptions && "&".concat(state.parsedOptions, "&cover=contain")),
    srcSet: state.srcSet,
    sizes: "(height: ".concat(imageFullCentered, "px) 100vh, ").concat(imageFullCentered.height, "px"),
    style: loadedImgStyle,
    ref: imageRef,
    onLoad: handleImageLoaded,
    onError: onError,
    loading: "lazy"
  }))), state.origin === 'external' && React.createElement(Img, {
    alt: alt,
    title: title,
    src: src,
    style: loadedImgStyle,
    ref: imageRef,
    onLoad: handleImageLoaded,
    onError: onError
  })));
});
ImageFullCentered.propTypes = process.env.NODE_ENV !== "production" ? {
  style: PropTypes.object,
  title: PropTypes.string,
  imageFullCentered: PropTypes.shape({
    imageHeight: PropTypes.number.isRequired,
    aspectRatio: PropTypes.string.isRequired,
    breakpointStep: PropTypes.number,
    height: PropTypes.string.isRequired
  }),
  state: PropTypes.shape({
    origin: PropTypes.string,
    fadeIn: PropTypes.string,
    imgLoaded: PropTypes.bool,
    isVisible: PropTypes.bool,
    key: PropTypes.string,
    origin: PropTypes.string,
    parseOptions: PropTypes.string,
    retinr: PropTypes.bool,
    seenBefor: PropTypes.bool,
    srcSet: PropTypes.string
  }),
  bgColor: PropTypes.string,
  LQIP: PropTypes.string,
  alt: PropTypes.string,
  placeholderStyle: PropTypes.object,
  src: PropTypes.string,
  imageRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  onError: PropTypes.func,
  handleImageLoaded: PropTypes.func,
  imageStyle: PropTypes.object
} : {};